import React from 'react';
import { Redirect } from 'react-router-dom';
import { LocationsUri } from './routes';

export const Home = (): JSX.Element => <Redirect to={LocationsUri} />;
